/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebhookEvent { 
    id: string;
    url: string;
    status: string;
    status_changed: string;
    last_modified: string;
    event: string;
}

